import ReleaseNotes from './ReleaseNotes'
import slice from './releaseNotes.slice'

export const { name, reducer } = slice

export * from './releaseNotes.asyncActions'
export * from './releaseNotes.selectors'

export default ReleaseNotes
